<template>
    <div class="d-flex flex-column schema-table">
        <div v-if="!tableOnly" class="d-flex align-center mb-5">
            <v-text-field
                v-model="searchText"
                class="no-print"
                label="Search"
                hide-details
                dense
                color="primary"
                outlined
                prepend-inner-icon="mdi-magnify" />

            <slot name="add-button">
                <app-icon-button
                    v-if="canAdd"
                    class="ml-4 no-print"
                    color="primary"
                    icon="mdi-plus"
                    @click="add" />
                <app-button
                    v-if="canAdd"
                    class="ml-4 no-print"
                    color="primary"
                    @click="onboard">
                    Onboard
                </app-button>
            </slot>
            <schema-excel-export-button
                v-if="!disableExport"
                v-bind="$attrs"
                class="ml-4 no-print"
                :entity-key="entityKey" />
        </div>

        <v-card :class="cardClasses" :elevation="outlined ? 0 : 4">
            <component
                :is="tableComponent"
                :key="entityKey"
                ref="schemaDataTable"
                class="flex-grow-1"
                v-bind="$attrs"
                :entity-key="entityKey"
                :search-text="searchText"
                :readonly="readonly"
                :has-item-page="hasItemPage"
                @edit="edit"
                @delete="deleteItem">
                <template #extra-actions="{ item }">
                    <v-tooltip v-if="item.paymentType == 'PurchaseOrder'" bottom>
                        <template #activator="{ on, attrs }">
                            <v-btn icon :loading="loading">
                                <v-icon
                                    fab
                                    color="primary"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click.stop="openDatePicker(item)">
                                    mdi-calendar
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Change End Date</span>
                    </v-tooltip>
                    <slot name="extra-actions" :item="item" />
                </template>
            </component>
        </v-card>

        <schema-form-dialog
            :entity-key="entityKey"
            :value="editedItem"
            :form="form"
            v-bind="$attrs"
            @input="onItemSaved" />

        <onboard-school-dialog
            :value="showOnboardSchoolDialog"
            v-bind="$attrs"
            @input="onOnboardComplete" />
        <app-message-dialog
            v-model="showYearDialog"
            title="End Date Changed"
            @ok="showYearDialog = false">
            <p>
                The end date was changed to {{ selectedDate }}
            </p>
        </app-message-dialog>

        <v-dialog v-model="showDatePicker" width="300">
            <v-card>
                <v-date-picker
                    v-model="selectedDate"
                    :min="today().toISO()"
                    @input="updateEndDate" />
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import tableMixin from "@/features/schemas/mixins/tableMixin";
import OnboardSchoolDialog from '@/features/schools/dialogs/OnboardSchoolDialog.vue';
import { update, get } from "@/services/apiService";
import { today } from "@/services/dateUtility";

export default {
    components: { OnboardSchoolDialog },
    mixins:[tableMixin],
    types: [
        "school"
    ],
    data() {
        return {
            showOnboardSchoolDialog: false,
            showYearDialog: false,
            loading: false,
            showDatePicker: false,
            selectedDate: null,
            currentItem: null
        }
    },
    methods: {
        onboard() {
            this.showOnboardSchoolDialog = true;
        },
        async onOnboardComplete() {
            this.showOnboardSchoolDialog = false;
            await this.refresh();
        },
        openDatePicker(item) {
            this.currentItem = item;
            this.showDatePicker = true;
        },
        async updateEndDate() {
            this.loading = true;
            try {
                let subscription = await get("subscriptions", this.currentItem.subscriptionId);
                subscription.endAt = this.selectedDate;
                await update("subscriptions", subscription);
                this.showDatePicker = false;
                this.showYearDialog = true;
                await this.refresh();
            } finally {
                this.loading = false;
            }
        },
        today
    }

};
</script>
